import { Modal } from 'ALIASED-antd';
import { ModalStaticFunctions } from 'ALIASED-antd/es/modal/confirm';
import { ModalProps } from 'antd';
import { ComponentType } from 'react';
import styled from 'styled-components';

export const StyledModal: ComponentType<ModalProps> = styled(Modal)`
  .ant-modal-content {
    padding: 0px;
  }

  .ant-modal-header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    padding: 16px 24px;
  }

  .ant-modal-body {
    padding: 16px 24px;
  }

  .ant-modal-footer {
    padding: 16px 24px;
    border-top: 1px solid rgba(0, 0, 0, 0.06);
  }
`;

const StyledAntModal = StyledModal as ComponentType<ModalProps> & ModalStaticFunctions;

StyledAntModal.warning = Modal.warning;
StyledAntModal.success = Modal.success;
StyledAntModal.error = Modal.error;
StyledAntModal.confirm = Modal.confirm;
StyledAntModal.info = Modal.info;
StyledAntModal.warn = Modal.warn;

export { StyledAntModal };
